<template>
    <defaultSec :title="'会话列表'">
        <keep-alive>
            <el-form :inline="true" :model="formParam" class="demo-form-inline select-wrap" size="mini">
                <el-form-item label="开始时间">
                    <el-date-picker
                        v-model="formParam.startDate"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-date-picker
                        v-model="formParam.endDate"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="initList">查询</el-button>

                </el-form-item>
            </el-form>
        </keep-alive>
        <tablePagination :total="total" :pageSize="formParam.pageSize" @handlePage="handlePage">
            <el-table :data="dataList" border size="mini">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="第一条消息" prop="firstMessage"></el-table-column>
                <el-table-column label="最后一条消息" prop="lastMessage"></el-table-column>
                <el-table-column label="消息条数" prop="messageCount" width="80"></el-table-column>
                <el-table-column label="回复得分" prop="avgScore" width="80" ></el-table-column>
                <el-table-column label="状态" prop="status" width="90" >
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status=='completed'" type="success">已完成</el-tag>
                        <el-tag v-else type="danger">{{scope.row.status}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="耗时(s)" prop="totalDuration" width="80"></el-table-column>
                <el-table-column label="标签" prop="categoryTags" width="150" ></el-table-column>
                <el-table-column label="时间" width="180" >
                    <template slot-scope="scope">
                        开始：{{scope.row.startTime}}<br/>
                        结束：{{scope.row.endTime}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="80">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="warning " size="mini"
                                       @click="toDetail(scope.row)">详情
                            </el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
        </tablePagination>
    </defaultSec>
</template>

<script>
    import defaultSec from '@c/defaultSection'
    import tablePagination from '@c/tablePagination'
    export default {
        data() {
            return {
                formParam: {
                    pageSize: 15,
                    currentPage: 1,
                    startDate:'',endDate:''
                },
                dataList: [],
                propertyTypeList:[],
                propertyClassList:[],
                propertyList:[],
                total: 0
            }
        },
        components: {
            defaultSec, tablePagination
        },
        mounted(){
            this.initList()
        },
        methods: {
            initList() {
                this.dataList=[]
                this.$apiGet('lechun-ai/conversation/getConversationList', {  ...this.formParam}).then(res => {
                    console.log(res)
                    this.total = res.total;
                    this.dataList = res.list
                })
            },
            handlePage(page){
                this.formParam.currentPage = page;
                this.initList()
            },
            toDetail(row){
                this.$router.push({name: 'aiConversationDetail',params:{id:row.conversationId}})
            }
        }
    }
</script>


<style scoped>
    .expand-title {
        width: 70px;
        color: #444548;
        line-height: 30px;
        text-align: right;
        margin-right: 10px;
        font-weight: 600;
    }

    .expand-flex {
        justify-content: flex-start;
        align-items: center;
        align-content: center;
    }
</style>